import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";

export default function Navbar(props) {
  const [scroll, setScroll] = React.useState(0);
  const location = useLocation();

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScroll(document.documentElement.scrollTop);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Paths where the navbar should NOT be active by default
  const inactivePaths = ["/", "/backyard", "/editorial"]; // Add more if needed

  const isScrolled = scroll > 80;
  const isPathInactive = inactivePaths.includes(location.pathname);
  
  // If user scrolled or path is NOT in inactivePaths, activate navbar
  const className = isScrolled || !isPathInactive ? "fixed-navbar active" : "fixed-navbar";

  return (
    <div className="main-nav">
      <div className={className}>
        <Header
          hclass={props.hclass}
          Logo={props.Logo}
          topbarNone={props.topbarNone}
        />
      </div>
    </div>
  );
}
